<template>
    <div class="recent-searches-modal">
        <el-dialog v-model="visible" title="Recent Searches" width="500px" :before-close="handleClose">
            <div class="search-tabs">
                <el-tabs v-model="activeTab" @tab-change="handleTabChange">
                    <el-tab-pane label="Recent" name="recent">
                        <div class="recent-searches-content">
                            <!-- Today -->
                            <div v-if="recentSearches.today?.length" class="search-group">
                                <h3 class="group-title">Today</h3>
                                <div class="search-list">
                                    <div v-for="search in recentSearches.today" :key="search.id" class="search-item"
                                        @click="selectSearch(search)">
                                        <div class="search-icon">
                                            <i class="fas fa-search"></i>
                                        </div>
                                        <div class="search-content">
                                            <div class="search-query">
                                                {{ search.saved_name || `Search Results for "${search.query}"` }}
                                            </div>
                                            <div class="search-time">{{ search.formatted_time }}</div>
                                        </div>
                                        <div class="search-actions">
                                            <el-button type="text" size="small" @click.stop="copyLink(search)"
                                                title="Copy link">
                                                <i class="fas fa-link"></i>
                                            </el-button>
                                            <el-button v-if="!search.is_saved" type="text" size="small"
                                                @click.stop="saveSearch(search)" title="Save search">
                                                <i class="fas fa-bookmark"></i>
                                            </el-button>
                                            <el-button v-else type="text" size="small"
                                                @click.stop="unsaveSearch(search)" title="Unsave search" class="saved">
                                                <i class="fas fa-bookmark"></i>
                                            </el-button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Yesterday -->
                            <div v-if="recentSearches.yesterday?.length" class="search-group">
                                <h3 class="group-title">Yesterday</h3>
                                <div class="search-list">
                                    <div v-for="search in recentSearches.yesterday" :key="search.id" class="search-item"
                                        @click="selectSearch(search)">
                                        <div class="search-icon">
                                            <i class="fas fa-search"></i>
                                        </div>
                                        <div class="search-content">
                                            <div class="search-query">
                                                {{ search.saved_name || `Search Results for "${search.query}"` }}
                                            </div>
                                            <div class="search-time">{{ search.formatted_time }}</div>
                                        </div>
                                        <div class="search-actions">
                                            <el-button type="text" size="small" @click.stop="copyLink(search)"
                                                title="Copy link">
                                                <i class="fas fa-link"></i>
                                            </el-button>
                                            <el-button v-if="!search.is_saved" type="text" size="small"
                                                @click.stop="saveSearch(search)" title="Save search">
                                                <i class="fas fa-bookmark"></i>
                                            </el-button>
                                            <el-button v-else type="text" size="small"
                                                @click.stop="unsaveSearch(search)" title="Unsave search" class="saved">
                                                <i class="fas fa-bookmark"></i>
                                            </el-button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Last 7 Days -->
                            <div v-if="recentSearches.last_7_days?.length" class="search-group">
                                <h3 class="group-title">Last 7 Days</h3>
                                <div class="search-list">
                                    <div v-for="search in recentSearches.last_7_days" :key="search.id"
                                        class="search-item" @click="selectSearch(search)">
                                        <div class="search-icon">
                                            <i class="fas fa-search"></i>
                                        </div>
                                        <div class="search-content">
                                            <div class="search-query">
                                                {{ search.saved_name || `Search Results for "${search.query}"` }}
                                            </div>
                                            <div class="search-time">{{ search.formatted_date }} {{
                                                search.formatted_time }}</div>
                                        </div>
                                        <div class="search-actions">
                                            <el-button type="text" size="small" @click.stop="copyLink(search)"
                                                title="Copy link">
                                                <i class="fas fa-link"></i>
                                            </el-button>
                                            <el-button v-if="!search.is_saved" type="text" size="small"
                                                @click.stop="saveSearch(search)" title="Save search">
                                                <i class="fas fa-bookmark"></i>
                                            </el-button>
                                            <el-button v-else type="text" size="small"
                                                @click.stop="unsaveSearch(search)" title="Unsave search" class="saved">
                                                <i class="fas fa-bookmark"></i>
                                            </el-button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Last Month -->
                            <div v-if="recentSearches.last_month?.length" class="search-group">
                                <h3 class="group-title">Last Month</h3>
                                <div class="search-list">
                                    <div v-for="search in recentSearches.last_month" :key="search.id"
                                        class="search-item" @click="selectSearch(search)">
                                        <div class="search-icon">
                                            <i class="fas fa-search"></i>
                                        </div>
                                        <div class="search-content">
                                            <div class="search-query">
                                                {{ search.saved_name || `Search Results for "${search.query}"` }}
                                            </div>
                                            <div class="search-time">{{ search.formatted_date }} {{
                                                search.formatted_time }}</div>
                                        </div>
                                        <div class="search-actions">
                                            <el-button type="text" size="small" @click.stop="copyLink(search)"
                                                title="Copy link">
                                                <i class="fas fa-link"></i>
                                            </el-button>
                                            <el-button v-if="!search.is_saved" type="text" size="small"
                                                @click.stop="saveSearch(search)" title="Save search">
                                                <i class="fas fa-bookmark"></i>
                                            </el-button>
                                            <el-button v-else type="text" size="small"
                                                @click.stop="unsaveSearch(search)" title="Unsave search" class="saved">
                                                <i class="fas fa-bookmark"></i>
                                            </el-button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Older -->
                            <div v-if="Object.keys(recentSearches.older || {}).length" class="search-group">
                                <template v-for="(searches, month) in recentSearches.older" :key="month">
                                    <h3 class="group-title">{{ month }}</h3>
                                    <div class="search-list">
                                        <div v-for="search in searches" :key="search.id" class="search-item"
                                            @click="selectSearch(search)">
                                            <div class="search-icon">
                                                <i class="fas fa-search"></i>
                                            </div>
                                            <div class="search-content">
                                                <div class="search-query">
                                                    {{ search.saved_name || `Search Results for "${search.query}"` }}
                                                </div>
                                                <div class="search-time">{{ search.formatted_date }} {{
                                                    search.formatted_time }}</div>
                                            </div>
                                            <div class="search-actions">
                                                <el-button type="text" size="small" @click.stop="copyLink(search)"
                                                    title="Copy link">
                                                    <i class="fas fa-link"></i>
                                                </el-button>
                                                <el-button v-if="!search.is_saved" type="text" size="small"
                                                    @click.stop="saveSearch(search)" title="Save search">
                                                    <i class="fas fa-bookmark"></i>
                                                </el-button>
                                                <el-button v-else type="text" size="small"
                                                    @click.stop="unsaveSearch(search)" title="Unsave search"
                                                    class="saved">
                                                    <i class="fas fa-bookmark"></i>
                                                </el-button>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </div>

                            <!-- No results -->
                            <div v-if="!hasAnyRecentSearches" class="no-searches">
                                <div class="no-searches-icon">
                                    <i class="fas fa-search"></i>
                                </div>
                                <p>No recent searches found</p>
                            </div>
                        </div>
                    </el-tab-pane>

                    <el-tab-pane label="Saved" name="saved">
                        <div class="saved-searches-content">
                            <!-- Today -->
                            <div v-if="savedSearches.today?.length" class="search-group">
                                <h3 class="group-title">Today</h3>
                                <div class="search-list">
                                    <div v-for="search in savedSearches.today" :key="search.id"
                                        class="search-item saved-item" @click="selectSearch(search)">
                                        <div class="search-icon saved">
                                            <i class="fas fa-bookmark"></i>
                                        </div>
                                        <div class="search-content">
                                            <div class="search-query" @click.stop="editSearchName(search)">
                                                {{ search.name }}
                                                <i class="fas fa-edit edit-icon"></i>
                                            </div>
                                            <div class="search-time">{{ search.formatted_time }}</div>
                                        </div>
                                        <div class="search-actions">
                                            <el-button type="text" size="small" @click.stop="copyLink(search)"
                                                title="Copy link">
                                                <i class="fas fa-link"></i>
                                            </el-button>
                                            <el-button type="text" size="small" @click.stop="deleteSavedSearch(search)"
                                                title="Delete saved search" class="delete">
                                                <i class="fas fa-trash"></i>
                                            </el-button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Yesterday -->
                            <div v-if="savedSearches.yesterday?.length" class="search-group">
                                <h3 class="group-title">Yesterday</h3>
                                <div class="search-list">
                                    <div v-for="search in savedSearches.yesterday" :key="search.id"
                                        class="search-item saved-item" @click="selectSearch(search)">
                                        <div class="search-icon saved">
                                            <i class="fas fa-bookmark"></i>
                                        </div>
                                        <div class="search-content">
                                            <div class="search-query" @click.stop="editSearchName(search)">
                                                {{ search.name }}
                                                <i class="fas fa-edit edit-icon"></i>
                                            </div>
                                            <div class="search-time">{{ search.formatted_time }}</div>
                                        </div>
                                        <div class="search-actions">
                                            <el-button type="text" size="small" @click.stop="copyLink(search)"
                                                title="Copy link">
                                                <i class="fas fa-link"></i>
                                            </el-button>
                                            <el-button type="text" size="small" @click.stop="deleteSavedSearch(search)"
                                                title="Delete saved search" class="delete">
                                                <i class="fas fa-trash"></i>
                                            </el-button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Last 7 Days -->
                            <div v-if="savedSearches.last_7_days?.length" class="search-group">
                                <h3 class="group-title">Last 7 Days</h3>
                                <div class="search-list">
                                    <div v-for="search in savedSearches.last_7_days" :key="search.id"
                                        class="search-item saved-item" @click="selectSearch(search)">
                                        <div class="search-icon saved">
                                            <i class="fas fa-bookmark"></i>
                                        </div>
                                        <div class="search-content">
                                            <div class="search-query" @click.stop="editSearchName(search)">
                                                {{ search.name }}
                                                <i class="fas fa-edit edit-icon"></i>
                                            </div>
                                            <div class="search-time">{{ search.formatted_date }} {{
                                                search.formatted_time }}</div>
                                        </div>
                                        <div class="search-actions">
                                            <el-button type="text" size="small" @click.stop="copyLink(search)"
                                                title="Copy link">
                                                <i class="fas fa-link"></i>
                                            </el-button>
                                            <el-button type="text" size="small" @click.stop="deleteSavedSearch(search)"
                                                title="Delete saved search" class="delete">
                                                <i class="fas fa-trash"></i>
                                            </el-button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Last Month -->
                            <div v-if="savedSearches.last_month?.length" class="search-group">
                                <h3 class="group-title">Last Month</h3>
                                <div class="search-list">
                                    <div v-for="search in savedSearches.last_month" :key="search.id"
                                        class="search-item saved-item" @click="selectSearch(search)">
                                        <div class="search-icon saved">
                                            <i class="fas fa-bookmark"></i>
                                        </div>
                                        <div class="search-content">
                                            <div class="search-query" @click.stop="editSearchName(search)">
                                                {{ search.name }}
                                                <i class="fas fa-edit edit-icon"></i>
                                            </div>
                                            <div class="search-time">{{ search.formatted_date }} {{
                                                search.formatted_time }}</div>
                                        </div>
                                        <div class="search-actions">
                                            <el-button type="text" size="small" @click.stop="copyLink(search)"
                                                title="Copy link">
                                                <i class="fas fa-link"></i>
                                            </el-button>
                                            <el-button type="text" size="small" @click.stop="deleteSavedSearch(search)"
                                                title="Delete saved search" class="delete">
                                                <i class="fas fa-trash"></i>
                                            </el-button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Older -->
                            <div v-if="Object.keys(savedSearches.older || {}).length" class="search-group">
                                <template v-for="(searches, month) in savedSearches.older" :key="month">
                                    <h3 class="group-title">{{ month }}</h3>
                                    <div class="search-list">
                                        <div v-for="search in searches" :key="search.id" class="search-item saved-item"
                                            @click="selectSearch(search)">
                                            <div class="search-icon saved">
                                                <i class="fas fa-bookmark"></i>
                                            </div>
                                            <div class="search-content">
                                                <div class="search-query" @click.stop="editSearchName(search)">
                                                    {{ search.name }}
                                                    <i class="fas fa-edit edit-icon"></i>
                                                </div>
                                                <div class="search-time">{{ search.formatted_date }} {{
                                                    search.formatted_time }}</div>
                                            </div>
                                            <div class="search-actions">
                                                <el-button type="text" size="small" @click.stop="copyLink(search)"
                                                    title="Copy link">
                                                    <i class="fas fa-link"></i>
                                                </el-button>
                                                <el-button type="text" size="small"
                                                    @click.stop="deleteSavedSearch(search)" title="Delete saved search"
                                                    class="delete">
                                                    <i class="fas fa-trash"></i>
                                                </el-button>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </div>

                            <!-- No saved searches -->
                            <div v-if="!hasAnySavedSearches" class="no-searches">
                                <div class="no-searches-icon">
                                    <i class="fas fa-bookmark"></i>
                                </div>
                                <p>No saved searches found</p>
                            </div>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </el-dialog>

        <!-- Edit Name Dialog -->
        <el-dialog v-model="editDialogVisible" title="Edit Search Name" width="400px">
            <el-form @submit.prevent="updateSearchName">
                <el-form-item label="Search Name">
                    <el-input v-model="editingSearchName" placeholder="Enter search name" maxlength="255"
                        show-word-limit />
                </el-form-item>
            </el-form>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="editDialogVisible = false">Cancel</el-button>
                    <el-button type="primary" @click="updateSearchName">Save</el-button>
                </span>
            </template>
        </el-dialog>
    </div>
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import RecentSearchesApi from '@api/recentSearches.api.js'

const props = defineProps({
    modelValue: {
        type: Boolean,
        default: false
    }
})

const emit = defineEmits(['update:modelValue', 'search-selected'])

const visible = ref(false)
const activeTab = ref('recent')
const recentSearches = ref({
    today: [],
    yesterday: [],
    last_7_days: [],
    last_month: [],
    older: {}
})
const savedSearches = ref({
    today: [],
    yesterday: [],
    last_7_days: [],
    last_month: [],
    older: {}
})

// Edit name dialog
const editDialogVisible = ref(false)
const editingSearch = ref(null)
const editingSearchName = ref('')

const hasAnyRecentSearches = computed(() => {
    return (
        recentSearches.value.today?.length ||
        recentSearches.value.yesterday?.length ||
        recentSearches.value.last_7_days?.length ||
        recentSearches.value.last_month?.length ||
        Object.keys(recentSearches.value.older || {}).length
    )
})

const hasAnySavedSearches = computed(() => {
    return (
        savedSearches.value.today?.length ||
        savedSearches.value.yesterday?.length ||
        savedSearches.value.last_7_days?.length ||
        savedSearches.value.last_month?.length ||
        Object.keys(savedSearches.value.older || {}).length
    )
})

watch(() => props.modelValue, (newVal) => {
    visible.value = newVal
    if (newVal) {
        fetchData()
    }
})

watch(visible, (newVal) => {
    emit('update:modelValue', newVal)
})

const fetchData = async () => {
    await Promise.all([
        fetchRecentSearches(),
        fetchSavedSearches()
    ])
}

const fetchRecentSearches = async () => {
    try {
        const response = await RecentSearchesApi.getRecentSearches({ limit: 100 })
        if (response.data) {
            recentSearches.value = response.data
        }
    } catch (error) {
        console.error('Error fetching recent searches:', error)
        ElMessage.error('Failed to load recent searches')
    }
}

const fetchSavedSearches = async () => {
    try {
        const response = await RecentSearchesApi.getSavedSearches({ limit: 50 })
        if (response.data) {
            savedSearches.value = response.data
        }
    } catch (error) {
        console.error('Error fetching saved searches:', error)
        ElMessage.error('Failed to load saved searches')
    }
}

const handleTabChange = (tabName) => {
    activeTab.value = tabName
}

const handleClose = () => {
    visible.value = false
}

const copyLink = (search) => {
    const query = search.query || search.search_query
    const url = `${window.location.origin}/search?q=${encodeURIComponent(query)}`
    navigator.clipboard.writeText(url).then(() => {
        ElMessage.success('Link copied to clipboard')
    }).catch(() => {
        ElMessage.error('Failed to copy link')
    })
}

const saveSearch = async (search) => {
    try {
        await RecentSearchesApi.saveSearch({
            model_log_id: search.id
        })
        ElMessage.success('Search saved successfully')
        await fetchRecentSearches()
        await fetchSavedSearches()
    } catch (error) {
        console.error('Error saving search:', error)
        ElMessage.error('Failed to save search')
    }
}

const unsaveSearch = async (search) => {
    try {
        // Find the saved search ID
        const savedSearch = findSavedSearchByModelLogId(search.id)
        if (savedSearch) {
            await RecentSearchesApi.deleteSavedSearch(savedSearch.id)
            ElMessage.success('Search unsaved successfully')
            await fetchRecentSearches()
            await fetchSavedSearches()
        }
    } catch (error) {
        console.error('Error unsaving search:', error)
        ElMessage.error('Failed to unsave search')
    }
}

const findSavedSearchByModelLogId = (modelLogId) => {
    const allSavedSearches = [
        ...(savedSearches.value.today || []),
        ...(savedSearches.value.yesterday || []),
        ...(savedSearches.value.last_7_days || []),
        ...(savedSearches.value.last_month || []),
        ...Object.values(savedSearches.value.older || {}).flat()
    ]
    return allSavedSearches.find(search => search.model_log_id === modelLogId)
}

const deleteSavedSearch = async (search) => {
    try {
        await ElMessageBox.confirm(
            'Are you sure you want to delete this saved search?',
            'Confirm Delete',
            {
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }
        )

        await RecentSearchesApi.deleteSavedSearch(search.id)
        ElMessage.success('Saved search deleted successfully')
        await fetchRecentSearches()
        await fetchSavedSearches()
    } catch (error) {
        if (error !== 'cancel') {
            console.error('Error deleting saved search:', error)
            ElMessage.error('Failed to delete saved search')
        }
    }
}

const editSearchName = (search) => {
    editingSearch.value = search
    editingSearchName.value = search.name
    editDialogVisible.value = true
}

const updateSearchName = async () => {
    try {
        await RecentSearchesApi.updateSavedSearchName(
            editingSearch.value.id,
            editingSearchName.value
        )
        ElMessage.success('Search name updated successfully')
        editDialogVisible.value = false
        await fetchRecentSearches()
        await fetchSavedSearches()
    } catch (error) {
        console.error('Error updating search name:', error)
        ElMessage.error('Failed to update search name')
    }
}

const selectSearch = (search) => {
    const query = search.query || search.search_query
    emit('search-selected', query)
    handleClose()
}

onMounted(() => {
    visible.value = props.modelValue
})
</script>

<style scoped>
.recent-searches-modal .el-dialog__body {
    padding: 0 20px 20px;
}

.search-tabs {
    margin-top: 10px;
}

.search-group {
    margin-bottom: 24px;
}

.group-title {
    font-size: 14px;
    font-weight: 600;
    color: #374151;
    margin: 0 0 12px 0;
    padding: 0 16px;
}

.search-list {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.search-item {
    display: flex;
    align-items: center;
    padding: 12px 16px;
    border-radius: 8px;
    cursor: pointer;
    transition: background-color 0.2s;
}

.search-item:hover {
    background-color: #f9fafb;
}

.search-item.saved-item:hover {
    background-color: #fef3c7;
}

.search-icon {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f3f4f6;
    border-radius: 6px;
    margin-right: 12px;
    color: #6b7280;
    font-size: 14px;
}

.search-icon.saved {
    background-color: #fef3c7;
    color: #d97706;
}

.search-content {
    flex: 1;
    min-width: 0;
}

.search-query {
    font-size: 14px;
    color: #111827;
    font-weight: 500;
    margin-bottom: 2px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.edit-icon {
    font-size: 12px;
    color: #6b7280;
    margin-left: 8px;
    opacity: 0;
    transition: opacity 0.2s;
}

.search-query:hover .edit-icon {
    opacity: 1;
}

.search-time {
    font-size: 12px;
    color: #6b7280;
}

.search-actions {
    display: flex;
    gap: 4px;
    opacity: 0;
    transition: opacity 0.2s;
}

.search-item:hover .search-actions {
    opacity: 1;
}

.search-actions .el-button {
    padding: 4px 8px;
    min-height: auto;
    color: #6b7280;
}

.search-actions .el-button:hover {
    color: #374151;
    background-color: #f3f4f6;
}

.search-actions .el-button.saved {
    color: #d97706;
}

.search-actions .el-button.saved:hover {
    color: #92400e;
    background-color: #fef3c7;
}

.search-actions .el-button.delete {
    color: #dc2626;
}

.search-actions .el-button.delete:hover {
    color: #991b1b;
    background-color: #fef2f2;
}

.no-searches {
    text-align: center;
    padding: 40px 20px;
    color: #6b7280;
}

.no-searches-icon {
    font-size: 48px;
    margin-bottom: 16px;
    opacity: 0.5;
}

.no-searches p {
    margin: 0;
    font-size: 14px;
}

.dialog-footer {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
}
</style>
